import { useEffect, useState } from "react";
import Loading from "../../../components/Loading";
import CollapseCard from "../../../components/CollapseCard";
import { TestCaseTypes } from "../../../interfaces/TestCaseTypes";
import EmptyState from "../../../components/EmptyState";
import DownIcon from "@mui/icons-material/ArrowDropDown";
import UpIcon from "@mui/icons-material/ArrowDropUp";
import LineIcon from "@mui/icons-material/UnfoldMoreOutlined";
import { colors } from "../../../assets/colors";
import { ProjectsTypes } from "../../../interfaces/ProjectsTypes";
import {
  Box,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import ButtonLoading from "../../../components/ButtonLoading";
import SubTitle from "../../../components/SubTitle";
import { SuiteTypes } from "../../../interfaces/SuiteTypes";
import TrashIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import AddIcon from "@mui/icons-material/AddCircle";
import ShareIcon from "@mui/icons-material/Share";
import { toast } from "react-toastify";
import DrawerSuite from "../components/DrawerSuite";
import DialogShare from "../components/DialogShare";
import DialogCreateExecution from "../components/DialogCreateExecution";
import DialogImportTestCases from "../components/DialogImportTestCases";
import DialogTestCase from "../components/DialogTestCase";
import DialogConfirm from "../../../components/DialogConfirm";
import { createUpdateTestCase, deleteSuite } from "../../../api/projects";
import { ActionTypeEnum } from "../../../interfaces/HistoryTypes";
import { mountHistory } from "../../../utils/history";
import { createHistory } from "../../../api/history";
import { textAlign } from "html2canvas/dist/types/css/property-descriptors/text-align";
import Row from "../../../components/layout/Row";
import Input from "../../../components/Input";
import { USER_DATA } from "../../../utils/constants";
import { useSearchParams } from "react-router-dom";

interface Props {
  suites: SuiteTypes[];
  loading: boolean;
  currentProject: ProjectsTypes;
  reload: () => void;
}

export default function TestCasesTab({
  suites,
  loading,
  currentProject,
  reload,
}: Props) {
  const [openDrawer, setOpenDrawer] = useState(false);
  const [openDrawerTestCase, setOpenDrawerTestCase] = useState(false);
  const [openDialogImportTestCase, setOpenDialogImportTestCase] =
    useState(false);

  const [testCaseSelected, setTestCaseSelected] =
    useState<TestCaseTypes | null>(null);

  const [selectedSuite, setSelectedSuite] = useState<SuiteTypes>();

  const [openShare, setOpenShare] = useState(false);
  const [openCreateExecution, setOpenCreateExecution] = useState(false);
  const [suitesToExecution, setSuitesToExecution] = useState<SuiteTypes[]>([]);
  const [openDelete, setOpenDelete] = useState(false);

  const [searchParams] = useSearchParams();
  const test_case_id = searchParams.get("test_case_id");

  useEffect(() => {
    if (
      test_case_id &&
      Object.keys(currentProject).length > 0 &&
      suites.length > 0
    ) {
      setTestCaseSelected(findTestCaseById(suites, test_case_id));
      setOpenDrawerTestCase(true);
    }
  }, [suites, test_case_id]);

  const findTestCaseById = (data: SuiteTypes[], testCaseId: string) => {
    for (const suite of data) {
      const testCase = suite.test_cases.find(
        (tc) => tc.id === Number(testCaseId)
      );
      if (testCase) {
        return testCase;
      }
    }

    return null; // Retorna null se não encontrar
  };

  // repetido
  const renderPriority = (priority: string) => {
    switch (priority) {
      case "LOW":
        return <UpIcon sx={{ color: "green" }} />;
      case "MEDIUM":
        return <LineIcon sx={{ color: "orange" }} />;
      case "HIGH":
        return <DownIcon sx={{ color: "red" }} />;
      default:
        return <LineIcon sx={{ color: "orange" }} />;
    }
  };

  const openAddTestCase = () => {
    if (suites.length > 0) {
      setOpenDrawerTestCase(true);
    } else {
      toast.error(
        "Nenhuma suite cadastrada. Cadastre uma suite de testes antes."
      );
    }
  };

  const createExecution = () => {
    if (suites.length > 0) {
      setSuitesToExecution(suites);
      setOpenCreateExecution(true);
    } else {
      toast.error(
        "Nenhuma suite cadastrada. Cadastre uma suite de testes antes."
      );
    }
  };

  const closeDrower = (shouldReload?: boolean) => {
    setOpenDrawer(false);
    setSelectedSuite(undefined);
    if (shouldReload) {
      reload();
    }
  };

  const closeDrowerTestCase = (shouldReload?: boolean) => {
    setOpenDrawerTestCase(false);
    setTestCaseSelected(null);
    if (shouldReload) {
      reload();
    }
  };

  const deleteTestSuite = (responseOk: any) => {
    setOpenDelete(false);
    if (!responseOk) {
      return;
    }

    deleteSuite(selectedSuite as SuiteTypes)
      .then(() => {
        toast.success("Caso de Teste excluído com sucesso");
        createHistory(
          mountHistory(
            currentProject.project_id,
            ActionTypeEnum.DELETE,
            "Suite: " + selectedSuite?.title
          )
        );
        reload();
      })
      .catch((e) => {
        toast.error("Ocorreu um problema, tente mais tarde!");
      })
      .finally(() => {});
  };

  const [newTestCaseTitle, setNewTestCaseTitle] = useState("");

  const handleKeyPress = (suite: SuiteTypes, event: any) => {
    if (event.key === "Enter") {
      event.preventDefault();
      setNewTestCaseTitle("");

      const data = [
        {
          title: newTestCaseTitle,
          id: new Date().getTime(),
          project_id: currentProject.project_id,
          suite: suite.id,
        },
      ];

      const userData = localStorage.getItem(USER_DATA);
      const user_uuid = userData ? JSON.parse(userData).uid : "";
      const project_id = currentProject.project_id;

      createUpdateTestCase(user_uuid, project_id, suite.id, data, "")
        .then(() => {
          reload();
          toast.success("Casos de teste adicionado com sucesso");
          createHistory(
            mountHistory(
              project_id,
              ActionTypeEnum.CREATE,
              "Caso de Testes criado: " + newTestCaseTitle
            )
          );
        })
        .catch((e) => {
          console.log(e);
          toast.error("Ocorreu um problema, tente mais tarde!!!!");
        });
    }
  };

  return (
    <>
      <Box sx={styles.buttonsContainer}>
        <ButtonLoading
          label="Add Suite"
          onClick={() => setOpenDrawer(true)}
          style={styles.button}
        />

        <ButtonLoading
          label="Add Caso de Teste"
          onClick={openAddTestCase}
          style={styles.button}
        />

        <ButtonLoading
          label="Criar execução"
          onClick={createExecution}
          style={styles.button}
        />

        <ButtonLoading
          label="Importar Casos de Teste"
          onClick={() => setOpenDialogImportTestCase(true)}
          style={styles.button}
        />

        <IconButton
          onClick={() => {
            setOpenShare(true);
          }}
        >
          <ShareIcon style={styles.shareIcon} />
          <span style={styles.shareText}>Exportar</span>
        </IconButton>
      </Box>

      {loading && (
        <div style={styles.content}>
          <Loading />
        </div>
      )}

      {currentProject && suites && !loading && (
        <div style={styles.content}>
          {!openDialogImportTestCase &&
            suites.map((suite: SuiteTypes, index) => {
              return (
                <CollapseCard
                  key={index}
                  title={suite.title}
                  moreInfo={
                    <>
                      <br />
                      <SubTitle
                        text={`${suite.test_cases.length} casos de testes`}
                        style={styles.suiteSubtitle}
                      />
                    </>
                  }
                  iconDelete={<TrashIcon sx={styles.iconSuite} />}
                  iconEdit={<EditIcon sx={styles.iconSuite} />}
                  iconAdd={<AddIcon sx={styles.iconSuite} />}
                  actionDelete={() => {
                    setSelectedSuite(suite);
                    setOpenDelete(true);
                  }}
                  actionEdit={() => {
                    setSelectedSuite(suite);
                    setOpenDrawer(true);
                  }}
                  actionAdd={() => {
                    setOpenDrawerTestCase(true);
                  }}
                >
                  <Box sx={styles.tableTestCasesContainer}>
                    <Table stickyHeader>
                      {suite.test_cases.length > 0 && (
                        <TableHead>
                          <TableRow>
                            <TableCell sx={styles.titleTableTestCase}>
                              Titulo
                            </TableCell>
                            <TableCell sx={styles.titleTableTestCase}>
                              Descrição
                            </TableCell>
                            <TableCell sx={styles.titleTableTestCase}>
                              Resultado Esperado
                            </TableCell>
                            <TableCell sx={styles.titleTableTestCase}>
                              Tipo
                            </TableCell>
                          </TableRow>
                        </TableHead>
                      )}
                      <TableBody>
                        {suite.test_cases.length == 0 && (
                          <span style={styles.emptySuite}>
                            Nenhum caso de teste para essa suite.
                          </span>
                        )}
                        {suite.test_cases.length > 0 &&
                          suite.test_cases.map((testcase: TestCaseTypes) => (
                            <TableRow
                              key={testcase.id}
                              hover
                              style={styles.rowTestCases}
                              onClick={() => {
                                setTestCaseSelected(testcase);
                                setOpenDrawerTestCase(true);
                              }}
                            >
                              <TableCell sx={styles.titleTestCase}>
                                {renderPriority(testcase.priority)}
                                {testcase.title}
                              </TableCell>
                              <TableCell sx={styles.infoTestCase}>
                                {testcase.description}
                              </TableCell>
                              <TableCell sx={styles.infoTestCase}>
                                {testcase.expected_result}
                              </TableCell>
                              <TableCell
                                sx={{
                                  ...styles.infoTestCase,
                                  width: 100,
                                }}
                              >
                                {testcase.type === "MANUAL" ? (
                                  <Row style={{ gap: 8 }}>
                                    <i className="material-icons">back_hand</i>
                                    <span>Manual</span>
                                  </Row>
                                ) : testcase.type === "AUTOMATED" ? (
                                  <Row style={{ gap: 8 }}>
                                    <i className="material-icons">code</i>
                                    <span>Automatizado</span>
                                  </Row>
                                ) : testcase.type === "INTEGRATION" ? (
                                  <Row style={{ gap: 8 }}>
                                    <i className="material-icons">settings</i>
                                    <span>Integração</span>
                                  </Row>
                                ) : null}
                              </TableCell>
                            </TableRow>
                          ))}
                      </TableBody>
                    </Table>

                    <Input
                      variant="standard"
                      placeholder="+ Novo Caso de Teste (pressione Enter para adicionar)"
                      value={newTestCaseTitle}
                      onChange={(e) => setNewTestCaseTitle(e.target.value)} // Atualiza o estado com o valor do campo
                      onKeyPress={(e) => handleKeyPress(suite, e)} // Chama a função ao pressionar Enter
                      style={{ marginLeft: 12, marginTop: 12, width: "98%" }} // Estilização do campo
                    />
                  </Box>
                </CollapseCard>
              );
            })}
        </div>
      )}

      {currentProject && suites.length === 0 && !loading && (
        <EmptyState text="Nenhuma suite encontrada. Cadastre uma suite de testes, e depois um caso de teste." />
      )}

      {openDelete && (
        <DialogConfirm
          onResponse={deleteTestSuite}
          entity="a suite de testes"
        />
      )}

      <DialogShare
        close={() => setOpenShare(false)}
        open={openShare}
        suites={suites}
      />

      {openCreateExecution ? (
        <DialogCreateExecution
          close={() => {
            setOpenCreateExecution(false);
            reload();
          }}
          open={openCreateExecution}
          suites={suitesToExecution}
          currentProject={currentProject}
        />
      ) : null}

      <DialogImportTestCases
        open={openDialogImportTestCase}
        close={() => setOpenDialogImportTestCase(false)}
        suites={suites}
        projectId={currentProject.project_id}
        reload={reload}
      />

      {openDrawer ? (
        <DrawerSuite
          close={closeDrower}
          currentProject={currentProject}
          selectedSuite={selectedSuite}
        />
      ) : null}

      {openDrawerTestCase ? (
        <DialogTestCase
          open={openDrawerTestCase}
          close={closeDrowerTestCase}
          currentProject={currentProject}
          suites={suites}
          testCaseSelected={testCaseSelected}
        />
      ) : null}
    </>
  );
}

const styles = {
  buttonsContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    width: "100%",
    marginTop: 4,
  },

  button: {
    width: 220,
    marginLeft: 12,
    marginTop: 0,
  },

  shareIcon: {
    width: 16,
    height: 16,
    color: colors.gray,
    marginLeft: 12,
  },

  shareText: {
    color: colors.gray,
    fontSize: 14,
    paddingLeft: 6,
  },

  content: {
    backgroundColor: colors.white,
    marginTop: 50,
    marginLeft: 12,
    marginRight: 12,
  },

  testCaseTitleContent: {
    justifyContent: "start",
    alignItems: "center",
    display: "flex",
    flexDirection: "row",
  },

  testCaseTitle: {
    fontSize: 14,
    fontWeight: "400",
    color: colors.black,
    width: 400,
    marginLeft: 10,
  },

  testCaseDescription: {
    fontSize: 12,
    fontWeight: "300",
    color: colors.gray,
  },

  suiteSubtitle: {
    marginTop: 0,
    marginBottom: 0,
    opacity: 0.6,
    fontWeight: "400",
  },

  iconSuite: {
    color: colors.gray,
    width: 16,
    height: 16,
  },

  emptySuite: {
    color: colors.gray,
    fontSize: 12,
    margin: 20,
  },

  titleTableTestCase: {
    fontSize: 14,
    fontWeight: "600",
    color: colors.black,
    cursos: "pointer",
    textAlign: "left",
  },

  tableTestCasesContainer: {
    margin: 2,
    cursos: "pointer",
  },

  rowTestCases: {
    cursor: "pointer",
  },

  titleTestCase: {
    paddingTop: 2,
    paddingBottom: 2,
    display: "flex",
    cursos: "pointer",
    textAlign: "left",
    justifyContent: "left",
  },

  infoTestCase: {
    paddingTop: 2,
    paddingBottom: 2,
    cursos: "pointer",
    textAlign: "left",
  },
};
